export default __webpack_public_path__ + "static/location-1e46b7639f0d2596daa807203ca84234.png";